export enum SeasonTypeAction {
    SET_SELECTED_SEASON = "SET_SELECTED_SEASON",
}
